module.exports = __webpack_public_path__ + "static/media/new-arrivals.2cb6de64.svg";